<template>
  <div class="app">
    <Loader v-if="globalLoading && fc_loader" />
    <div
      class="icon-wrap home"
      @click="goHome"
      v-if="Number(globalFairConfig.FC_HOME_BTN) && !hideHomeAndBack"
    >
      <div v-tooltip="$t('tooltips.home')">
        <span class="material-icons">home</span>
      </div>
    </div>
    <div
      class="icon-wrap back"
      @click="goBack"
      v-if="Number(globalFairConfig.FC_BACK_BTN) && !hideHomeAndBack"
    >
      <div v-tooltip="$t('tooltips.back')">
        <span class="material-icons">arrow_back</span>
      </div>
    </div>
    <transition name="phone-overlay-fade">
      <phoneOverlay
        v-if="
          isPhoneVertical &&
            showPhoneOverlay &&
            Number(globalFairConfig.FC_PORTRAIT_INFO)
        "
        @hide-overlay="showPhoneOverlay = false"
      />
    </transition>
    <navigation
      v-if="!hideMenu"
      :avatar="avatar"
      :is-mobile="isMobile"
      @toggle-chat="toggleChat"
      @logout="logout"
      :new-messages="newMessagesCount"
      :notifications="notifications"
      :show-call="showCall"
      @show-call="handleShowCall"
      :incoming-call="incomingCall"
      @mute-chime="muteChime"
      :muted="chimeMuted"
    />
    <transition name="chat-fade">
      <chatComp
        v-if="isChatOpen"
        :navigate="chatProp"
        :mobile="isMobile"
        :on-call="onCall"
        :orientation="orientation"
        @close="toggleChat(false)"
        @resetchatprop="resetChatProp"
      />
    </transition>
    <video-modal
      :video-src="link"
      v-if="showModal"
      @close-modal="closeModal"
    ></video-modal>
    <html-modal
      v-if="htmlItem"
      :item="htmlItem"
      @close-modal="closeHtmlModal"
    ></html-modal>

    <router-view
      class="page"
      :class="{
        fullscreen: isPhoneVertical,
        portrait: !orientation,
        'no-side-bar': !showSidebar,
        'no-nav-bar': hideMenu,
        'has-footer': showFooter,
      }"
      :orientation="orientation"
      :video-links="videoLinks"
      @open-modal="openModal"
      @get-videos="getVideos"
      @open-chat="toggleChat(true)"
    />

    <footer-component :orientation="orientation" v-if="showFooter" />
    <side-bar
      :bottom="!orientation && isMobile"
      :mobile="isMobile"
      :group-icons="isMobile"
      @handle-chat="toggleChat"
      v-if="showSidebar"
    />
    <transition name="chat-fade">
      <errorcomp
        v-if="errorData && errorData.message"
        @close="closeError()"
        :error="errorData"
      />
    </transition>
    <transition name="chat-fade">
      <infoModal
        v-if="infoData && infoData.message"
        @close="closeInfo()"
        :info="infoData"
      />
    </transition>
    <transition name="chat-fade">
      <confirmModal
        v-if="confirmData"
        @close="closeConfirm()"
        :confirmprop="confirmData"
      />
    </transition>
    <transition name="chat-fade" v-if="incomingCall && showCall">
      <call-handler
        :usr_id="caller.usr_id"
        :usr_name="caller.usr_firstname + ' ' + caller.usr_lastname"
        @answer="handleCallAnswer"
        @close-overlay="closeOverlay"
      />
    </transition>
    <transition name="chat-fade" v-if="onCall">
      <call-wrap
        v-if="onCall"
        :self="screenStream !== null ? screenStream : stream"
        :other="otherStream"
        :screenShare="screenShareTrack !== null"
        :mute-self="muted"
        :hide-video="hideVideo"
        :can-share-screen="canShareScreen"
        :dummy-video="dummyVideo"
        :dummy-audio="dummyAudio"
        @share-screen="handleScreenShare"
        @mute="handleMuteSelf"
        @hide-video="handleHideVideo"
        @end-call="handleEndCall"
      />
    </transition>
    <audio src="./assets/audio/call-chime.mp3" loop ref="audio" />

    <proceedShortcut v-if="action" :action="action" @done="clearAction" />

    <poll-form v-if="showPollForm" @close="closePoll" />

    <div
      class="background-dim"
      v-if="confirmData || showPollForm"
      @click="handleCancelConfirm"
    ></div>
  </div>
</template>
<script>
import Loader from "@/components/Loader.vue";
import Peer from "simple-peer";
import VideoModal from "./components/video/EmbedModal";
import { cssVar, getHexColor, hexToHSLArr } from "@/js/colorHelpers.js";
import Nav from "./components/navigation/Nav";
import chat from "./components/chat/ChatWrap.vue";
import Footer from "./components/navigation/footer/Footer.vue";
import api from "./api";
import SideBar from "./components/navigation/SideBar";
import isMobileMixin from "./mixins/isMobileMixin";
import errorcomp from "./components/shared/ErrorComponent.vue";
import infoModal from "./components/shared/InfoModal.vue";
import confirmModal from "./components/shared/ConfirmModal.vue";
import proceedShortcut from "./components/shortcuts/proceed.vue";
import HtmlModal from "./components/video/HtmlModal";
import loadGA from "./js/ga.js";
import phoneOverlay from "./components/phoneOverlay.vue";
import { mapActions, mapGetters } from "vuex";
import CallHandler from "./components/web-rtc/CallHandler";
import CallWrap from "./components/web-rtc/CallWrap";
import { enableScroll, disableScroll } from "./js/preventScroll.js";
import Shortcut from "./js/shortcuts.js";
import pollForm from "@/views/ResubmitPollForm";

export default {
  components: {
    proceedShortcut,
    phoneOverlay,
    navigation: Nav,
    chatComp: chat,
    SideBar,
    confirmModal,
    errorcomp,
    VideoModal,
    infoModal,
    HtmlModal,
    footerComponent: Footer,
    CallHandler,
    CallWrap,
    Loader,
    pollForm,
  },
  data() {
    return {
      showPollForm: false,
      action: null,
      ogTitle: "",
      avatar: null,
      logo: null,
      navText: null,
      chatProp: null,
      errorData: null,
      infoData: null,
      confirmData: null,
      errorTimer: null,
      infoTimer: null,
      newMessagesCount: null,
      newMessageAudio: new Audio(
        require("@/assets/audio/new_message_sound.mp3")
      ),
      titleToggleInterval: null,
      notifications: [],
      paths: [
        "/login",
        "/register",
        "/validate",
        "/forgotpassword",
        "/resetpassword",
        "/linkedin",
        "/csv-login",
      ],
      checkSessionTimeout: null,
      getNotificationsTimeout: null,
      checkPollsTimeout: null,
      link: "",
      showModal: false,
      IOS_WINDOWORIENTATION_: {
        0: "portrait-primary",
        90: "landscape-primary",
      },
      orientation_: null,
      videoLinks: [],
      htmlItem: null,
      o9n: null,
      showPhoneOverlay: localStorage.getItem("hidePhoneOverlay") ? false : true,
      incomingCall: false,
      showCall: false,
      websocket: null,
      onCall: false,
      tabName: null,
      otherPeer: null,
      peer: null,
      caller: {
        usr_id: null,
        usr_firstname: "",
        usr_lastname: "",
        destination: "",
      },
      stream: null,
      otherStream: null,
      screenStream: null,
      videoTrack: null,
      audioTrack: null,
      screenShareTrack: null,
      muted: false,
      hideVideo: false,
      chimeMuted: false,
      canShareScreen: false,
      dummyVideo: false,
      dummyAudio: false,
    };
  },
  watch: {
    onCall(val) {
      if (val) {
        disableScroll();
      } else {
        enableScroll();
      }
    },
    isLoggedIn(val) {
      if (!val) {
        if (this.onCall) {
          this.handleEndCall();
        } else if (this.incomingCall) {
          this.handleEndCall(true);
        }
        if (this.websocket !== null) {
          this.handleDestroyWebsocket();
        }
        this.muteChime(true);
      }
    },
    newMessagesCount: {
      handler(val) {
        if (Number(val) > 0) this.playAudioAndToggleTitle();
        else this.resetTitle();
      },
    },
  },
  computed: {
    ...mapGetters([
      "googleUser",
      "webRTC",
      "globalLoading",
      "permissions",
      "publicPermissions",
      "globalFairConfig",
    ]),
    hideHomeAndBack() {
      return (
        this.$route.path.includes("/login") ||
        this.$route.path.includes("/admin") ||
        this.$route.path.includes("/register") ||
        this.$route.path.includes("/validate")
      );
    },
    fc_loader() {
      return !!Number(this.globalFairConfig.FC_LOADER);
    },
    fc_headfoot() {
      return !!Number(this.globalFairConfig.FC_HEADFOOT);
    },
    fc_sidemenu() {
      return !!Number(this.globalFairConfig.FC_SIDEMENU);
    },
    isGoogleSignedIn() {
      return this.gapi.auth2.getAuthInstance().isSignedIn.get();
    },
    isPhoneVertical() {
      return this.isMobile && !this.orientation;
    },
    orientation() {
      if (this.orientation_ === null || this.orientation_ === undefined) {
        return true;
      }
      if (this.orientation_.indexOf("portrait") !== -1) {
        return false;
      }
      return true;
    },
    hideMenu() {
      if (this.fc_headfoot) {
        return !this.$route.query.hidemenu == "true";
      } else {
        return true;
      }
    },
    showSidebar() {
      return false;
      // TODO what to do with sidebar?
      // if(this.fc_sidemenu) {
      //   if (this.hideMenu) {
      //     return false;
      //   }
      //   return this.$route.meta.sidebar;
      // }
      // else{
      //   return false
      // }
    },
    showFooter() {
      if (this.fc_headfoot) {
        return this.$route.meta.footer;
      } else {
        return false;
      }
    },
  },
  mixins: [isMobileMixin],
  beforeCreate() {
    async function initExternalScripts() {
      api.getFairConfig().then(async (data) => {
        const fairConfig = data.data.data;

        //one signal instance
        const OneSignal = window.OneSignal || [];
        OneSignal.push(async function() {
          OneSignal.init({
            appId: fairConfig.FC_APPID_ONESIGNAL,
            safari_web_id:
              "web.onesignal.auto." + fairConfig.FC_SAFARI_ONESIGNAL,
            notifyButton: {
              enable: true,
            },
          });
        });
        //one signal instance end

        //jira instance
        if (fairConfig.FC_JIRA == 1) {
          const script = document.createElement("script");

          script.setAttribute("src", fairConfig.FC_JIRA_BASE_SRC);
          script.setAttribute("data-key", fairConfig.FC_JIRA_DATA_KEY);
          script.setAttribute("data-base-url", fairConfig.FC_JIRA_BASE_URL);
          script.setAttribute("data-jsd-embedded", "");

          const bodyEl = document.getElementsByTagName("body")[0];
          bodyEl.appendChild(script);

          script.onload = () => {
            var DOMContentLoaded_event = document.createEvent("Event");
            DOMContentLoaded_event.initEvent("DOMContentLoaded", true, true);
            window.document.dispatchEvent(DOMContentLoaded_event);

            // unset max z-index
            const jiraEl = document.getElementById("jsd-widget");
            const oldStyle = jiraEl.getAttribute("style");
            jiraEl.setAttribute(
              "style",
              oldStyle + "z-index: 900; bottom: 40px; right: 20px;"
            );
          };
        }
        //jira instance end
      });
      // custom CSS logic
      const res = await api.getCss();
      const styleTag = document.createElement("style");
      styleTag.innerHTML = res.data;
      const bodyEl = document.getElementsByTagName("body")[0];
      bodyEl.appendChild(styleTag);
    }
    initExternalScripts();
  },
  created() {
    this.init();
    document.addEventListener("click", this.eventBusHandleClick);
  },
  mounted() {
    setInterval(() => {
      this.submitEventTracking();
    }, 60000);
    let check = false;
    if (window.orientation) {
      // safari ios
      check = true;
      window.onorientationchange = this.handleOriantationIOS_;
      this.handleOriantationIOS_();
    }
    if (screen.orientation) {
      check = true;
      try {
        screen.orientation.onchange = this.handleOrientation_;
        this.handleOrientation_();
      } catch (error) {
        console.log(error);
      }
      try {
        screen.onmozorientationchange = this.handleOrientation_;
        this.handleOrientation_();
      } catch (error) {
        console.log(error);
      }
      try {
        screen.onmsorientationchange = this.handleOrientation_;
        this.handleOrientation_();
      } catch (error) {
        console.log(error);
      }
    }
    if (!check) {
      this.o9n = require("o9n");
      this.o9n.orientation.onchange = this.handleO9nOrientation;
      this.handleO9nOrientation();
    }
  },
  methods: {
    ...mapActions([
      "setGoogleUser",
      "changeWebRTC",
      "setFcLoader",
      "setFcHeadFoot",
      "setFcSideMenu",
      "setPermissions",
      "setRolId",
      "setTrackingEvents",
      "setPublicPermissions",
    ]),
    async init() {
      this.setupShortcuts();
      this.saveTitle();
      this.generateUniqueKey();

      // interval functions
      await this.checkSession();
      await this.initConfigs();
      if (this.isLoggedIn) {
        this.getNotifications();
        this.checkPolls();
      }

      if (this.isPublic) await this.getPublicPermissions();
      await this.getFlavor();
      await this.listenForError();
      await this.listenForLoading();
      await this.listenForInfo();
      await this.listenForConfirm();
      await this.listenForChatProp();
      await this.listenForLoginSuccess();
      await this.listenForLogout();
      await this.listenForHtmlModal();
      this.checkRTC();
      this.listenForCall();
      this.listenForSupportChat();
      await this.getVideos();
      setTimeout(() => {
        let path = this.$router.currentRoute.path;
        if (this.isPublic && (path == "/login" || path == "/register"))
          this.$router.push("/");
      }, 1000);
    },
    setupShortcuts() {
      Shortcut.init(this);
    },
    refreshFairConfig() {
      setInterval(async () => {
        if (document.visibilityState == "hidden") return; // this is to not bug out window when you alt tab for long periods of time
        try {
          let res = await api.getFairConfig();
          this.updateFairConfig(res.data.data);
        } catch (error) {
          // this is intentinally empty block
        }
      }, 60 * 1000);
    },
    async initConfigs() {
      // Get config data
      try {
        let res = await api.getFairConfig();
        this.updateFairConfig(res.data.data);
        this.refreshFairConfig();
        if (res.data.data.GA_TAG) {
          setTimeout(loadGA(res.data.data.GA_TAG), 1);
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async getPublicPermissions() {
      try {
        const res = await api.getPublicPermissions();
        this.setPublicPermissions(res.data.permissions);
      } catch (error) {
        this.handleError(error);
      }
    },
    listenForLoading() {
      this.EventBus.$on("startLoading", () => {
        this.startLoading();
      });

      this.EventBus.$on("stopLoading", () => {
        this.stopLoading();
      });
    },
    listenForError() {
      this.EventBus.$on("error", (err) => {
        this.processError(err);
      });
    },
    processError(error) {
      let data = {};
      if (!error) return;
      if (error) data.message = error;
      if (error.request) data.message = error.request;
      if (error.message) data.message = error.message;
      if (error.response && error.response.data && error.response.data.message)
        data.message = error.response.data.message;
      this.errorData = data;

      if (this.errorTimer) {
        clearTimeout(this.errorTimer);
        this.errorTimer = null;
      }
      this.errorTimer = setTimeout(() => {
        this.closeError();
      }, 8000);
    },
    closeError() {
      this.errorData = null;
    },
    listenForConfirm() {
      // confirm: {
      // 	okButton ? okButton : 'Ok'
      // 	cancelButton ? cancelButton : 'Cancel'
      // 	title ? title : 'Are you sure?'
      // 	okCallback ? okCallback : ()=>{}
      // 	cancelCallback ? cancelCallback : ()=>{}
      // }
      this.EventBus.$on("confirm", (confirm) => {
        this.confirmData = confirm;
      });
    },
    handleCancelConfirm() {
      if (this.confirmData?.cancelCallback) this.confirmData.cancelCallback();
      this.closeConfirm();
    },
    closeConfirm() {
      this.confirmData = null;
    },
    listenForInfo() {
      this.EventBus.$on("info", (info) => {
        this.infoData = info;

        if (this.infoTimer) {
          clearTimeout(this.infoTimer);
          this.infoTimer = null;
        }
        this.infoTimer = setTimeout(() => {
          this.closeInfo();
        }, 8000);
      });
    },
    closeInfo() {
      this.infoData = null;
    },
    listenForCall() {
      if (Number(this.globalFairConfig.FC_CALL) !== 1 || !this.webRTC) {
        return;
      }
      this.EventBus.$on("make-call", this.handleCall);
    },
    listenForChatProp() {
      this.EventBus.$on("chatProp", (prop) => {
        // location can be: "dm", "public", "online"
        // if "dm" then userId is needed
        if (prop.location) {
          this.chatProp = prop;
          this.toggleChat(true);
        }
      });
    },
    resetChatProp() {
      this.chatProp = null;
    },
    handleOrientation_() {
      this.orientation_ = screen.orientation.type;
    },
    handleOriantationIOS_() {
      this.orientation_ = this.IOS_WINDOWORIENTATION_[window.orientation];
    },
    handleO9nOrientation() {
      this.orientation_ = this.o9n.orientation.type;
    },
    listenForLoginSuccess() {
      this.EventBus.$on("login", () => {
        this.startCheckSession();
        this.getNotifications();
        this.checkPolls();
      });
    },
    listenForLogout() {
      this.EventBus.$on("logout", () => {
        this.logout();
        this.stopGetNotifications();
        this.stopCheckPolls();
      });
    },
    listenForHtmlModal() {
      this.EventBus.$on("open-html-modal", (item) => {
        this.openHtmlModal(item);
      });
    },
    goToProfile() {
      this.$router.push({ path: "/profile" });
    },
    getFlavor() {
      this.getDefaultColors();
    },
    async getDefaultColors() {
      try {
        let res = await api.getDefaultColors();
        this.setUpColors(res.data);
      } catch (error) {
        this.handleError(error);
      }
    },
    setUpColors(colors) {
      if (!colors) {
        colors = {
          "main-color": "#fff",
          "secondary-color": "#000",
          interest_color: "#D35B30",
          goal_color: "#FCBF5E",
        };
      }
      const main_color_hex = getHexColor(colors["main-color"]);
      const main_color_hsl = hexToHSLArr(main_color_hex);

      const secondary_color_hex = getHexColor(colors["secondary-color"]);
      const secondary_color_hsl = hexToHSLArr(secondary_color_hex);

      const interest_color_hex = getHexColor(colors["interest_color"]);
      const interest_color_hsl = hexToHSLArr(interest_color_hex);

      const goal_color_hex = getHexColor(colors["goal_color"]);
      const goal_color_hsl = hexToHSLArr(goal_color_hex);

      cssVar("--main-color-h", main_color_hsl[0]);
      cssVar("--main-color-s", `${main_color_hsl[1]}%`);
      cssVar("--main-color-l", `${main_color_hsl[2]}%`);

      cssVar("--secondary-color-h", secondary_color_hsl[0]);
      cssVar("--secondary-color-s", `${secondary_color_hsl[1]}%`);
      cssVar("--secondary-color-l", `${secondary_color_hsl[2]}%`);

      cssVar("--interest-color-h", interest_color_hsl[0]);
      cssVar("--interest-color-s", `${interest_color_hsl[1]}%`);
      cssVar("--interest-color-l", `${interest_color_hsl[2]}%`);

      cssVar("--goal-color-h", goal_color_hsl[0]);
      cssVar("--goal-color-s", `${goal_color_hsl[1]}%`);
      cssVar("--goal-color-l", `${goal_color_hsl[2]}%`);
    },
    toggleChat(val) {
      try {
        this.setChat(val);
      } catch (error) {
        this.handleError(error);
      }
    },
    async firstLoad() {},
    async checkSession() {
      let checkIfOnAllowedPath = (currentPath) => {
        let pathsThatDontGetPushedToLogin = this.paths;
        if (pathsThatDontGetPushedToLogin.indexOf(currentPath) === -1)
          return true;
        return false;
      };
      const navigate = () => {
        try {
          localStorage.removeItem("sid");
          this.setLoggedIn(false);
          this.toggleChat(false);
          // let path = this.$router.currentRoute.path;
          // this is changed due to edge case while the app loads initially
          // this.$router.currentRoute.path will always be "/"
          let path = window.location.pathname;
          if (path.includes("admin")) {
            if (path !== "/admin/login") {
              this.$router.push("/admin/login");
            }
          } else if (checkIfOnAllowedPath(path)) {
            this.$router.push("/login");
          }
        } catch (error) {
          console.warn(error);
        }
      };
      let checkIfPublicOrLoggedInOrAdmin = () => {
        if (this.$route.meta.requiresLoginEvenIfPublic && !this.isLoggedIn) {
          navigate();
        }

        if (this.$route.meta.requiresLogin) {
          if (!(this.isPublic || this.isLoggedIn)) {
            navigate();
          }
        }

        if (this.$route.meta.requiresAdmin)
          if (!(this.isAdmin && this.isLoggedIn)) navigate();
      };
      try {
        let res = await api.checkSession();
        this.setPublic(res);
        if (!this.permissions) this.getPermissions();
        if (res && res.data && res.data.usr_id) {
          this.setLoggedIn(true);
          localStorage.setItem("usr_id", res.data.usr_id);
          localStorage.setItem("usd_id", res.data.usd_id);
          this.setRolId(res.data.rol_id);
          this.avatar = await this.getImageUsdId(res.data.usd_id);
          // this.newMessagesCount = res.data.unseen_msg_counter;
          // this.notifications = res.data.notification;
          // this.checkPoll(res);
          this.checkIfRoutedOnIllegalPages();
          this.connectWebSocket();
        } else {
          await this.logout();
        }
        //If its a public fair, and user logged out in another tab
        if (this.isPublic && !localStorage.getItem("sid")) {
          localStorage.removeItem("sid");
          this.setLoggedIn(false);
          this.toggleChat(false);
        }
        checkIfPublicOrLoggedInOrAdmin();
      } catch (error) {
        if (error && error.response) {
          if (error.response.data) this.setPublic(error.response);
          if (this.isLoggedIn) {
            this.handleError(error);
          }
          if (!this.isPublic) navigate();
        }
        if (this.onCall) {
          this.handleEndCall(true);
        }
      }

      this.startCheckSession();
    },
    async getNotifications() {
      try {
        const res = await api.getNotifications();
        this.newMessagesCount = res.data.unseen_msg_counter;
        this.notifications = res.data.notification;
      } catch (error) {
        console.warn(error);
      }

      this.startGetNotifications();
    },
    async startGetNotifications() {
      this.stopGetNotifications();
      this.getNotificationsTimeout = setTimeout(
        this.getNotifications,
        30 * 1000
      );
    },
    async stopGetNotifications() {
      if (this.getNotificationsTimeout) {
        clearTimeout(this.getNotificationsTimeout);
        this.getNotificationsTimeout = null;
      }
    },
    // async checkPolls () {
    //   try {
    //     const res = await api.checkPolls();
    //     if (
    //       res.data.active_poll.length > 0 &&
    //       !this.$route.path.includes("pollform")
    //     ) {
    //       this.openToast(this.$t("polls.resubmitMessage"));
    //       this.$router.push("/pollform");
    //     }
    //   } catch (error) {
    //     console.warn(error);
    //   }

    //   this.startCheckPolls();
    // },
    async startCheckPolls() {
      this.stopCheckPolls();
      this.checkPollsTimeout = setTimeout(this.checkPolls, 60 * 1000);
    },
    async stopCheckPolls() {
      if (this.checkPollsTimeout) {
        clearTimeout(this.checkPollsTimeout);
        this.checkPollsTimeout = null;
      }
    },
    checkIfRoutedOnIllegalPages() {
      let check = this.paths.some(
        (el) =>
          this.$route.path.includes(el) && !this.$route.path.includes("admin")
      );
      if (check) {
        this.$router.push("/");
      }
    },
    setPublic(res) {
      let isPublic = res.data.ispublic == 1;
      this.setIsPublic(isPublic);
      localStorage.setItem("public", isPublic);
    },
    async checkPolls() {
      const res = await api.checkPolls();
      if (res.data.active_poll.length > 0 && this.showPollForm == false) {
        let text = this.$t("polls.resubmitMessage");
        this.openToast(text);
        this.showPollForm = true;
      }
      this.startCheckPolls();
    },
    closePoll(pls_id) {
      this.callApiForClosePoll(pls_id);
      this.showPollForm = false;
    },
    stopCheckSession() {
      if (this.checkSessionTimeout) {
        clearTimeout(this.checkSessionTimeout);
        this.checkSessionTimeout = null;
      }
    },
    startCheckSession() {
      let timeoutInterval = document.visibilityState == "hidden" ? 30 : 3;
      this.stopCheckSession();
      this.checkSessionTimeout = setTimeout(
        this.checkSession,
        timeoutInterval * 1000
      );
    },
    openModal(link) {
      this.showModal = true;
      this.link = link;
    },
    closeModal() {
      this.link = "";
      this.showModal = false;
    },
    async getVideos() {
      try {
        let res = await api.getVideo();
        if (res.data.data) {
          this.videoLinks = res.data.data.filter(
            (el) => el.con_extension !== "ogg"
          );
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async logout() {
      try {
        if (localStorage.getItem("sid")) await api.logout();
      } catch (error) {
        this.handleError(error);
      } finally {
        localStorage.removeItem("sid");
        localStorage.removeItem("usr_id");
        this.setIsAdmin(false);
        this.setLoggedIn(false);
        this.toggleChat(false);
        this.setTrackingEvents(null);
        if (this.isGoogleSignedIn) {
          await this.gapi.auth2.getAuthInstance().signOut();
        }
        if (!this.isPublic) {
          this.$router.push("/login");
        } else {
          this.$router.push({ name: "Home" });
        }
      }
    },
    listenForSupportChat() {
      this.EventBus.$on("support-chat", this.handleSupport);
    },
    async handleSupport() {
      try {
        let res = await api.getSupport();
        if (res.data.usr_id) {
          this.EventBus.$emit("chatProp", {
            location: "dm",
            userId: res.data.usr_id,
          });
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async openHtmlModal(item) {
      this.htmlItem = item;
    },
    closeHtmlModal() {
      this.htmlItem = null;
    },
    eventBusHandleClick(e) {
      this.EventBus.$emit("handle-search", e);
    },
    checkRTC() {
      if (Peer.WEBRTC_SUPPORT && Number(this.globalFairConfig.FC_CALL) === 1) {
        this.changeWebRTC(true);
        if (
          navigator.mediaDevices &&
          "getDisplayMedia" in navigator.mediaDevices
        ) {
          this.canShareScreen = true;
        }
        window.addEventListener("beforeunload", () =>
          this.handleDestroyTab(this.tabName)
        );
        window.onunload = () => this.handleDestroyTab(this.tabName);
      }
    },
    handleDestroyWebsocket() {
      this.handleDestroyTab(this.tabName);
      this.websocket.close();
      this.websocket = null;
    },
    generateUniqueKey() {
      let length = 58;
      var ret = "";
      while (ret.length < length) {
        ret += Math.random()
          .toString(16)
          .substring(2);
      }
      let result = ret.substring(0, length);
      this.saveUniqueKey(result);
      return result;
    },
    handleDestroyTab() {
      api.destroyTab(this.tabName);
    },
    handleShowCall() {
      this.showCall = true;
    },
    closeOverlay() {
      this.showCall = false;
    },
    async handleCallAnswer(val) {
      this.otherPeer = this.caller.peer;
      this.showCall = false;
      this.incomingCall = false;
      this.muteChime(true);
      let res = {
        type: "answer",
        answer: val,
        destination: this.caller.destination,
        usr_id: this.caller.usr_id,
      };
      if (val) {
        await this.getUserMedia();
        this.onCall = true;
        this.peer = new Peer({
          initiator: false,
          trickle: false,
          stream: this.stream,
        });
        this.peer.on("error", (e) => console.log(e));
        this.peer.on("signal", (data) => {
          res.peer = data;
          this.websocket.send(JSON.stringify(res));
        });
        this.peer.signal(this.otherPeer);
        this.peer.on("track", (track) => {
          if (this.otherStream === null) {
            this.otherStream = new MediaStream();
          }
          this.otherStream.addTrack(track);
        });
        this.peer.on("close", () => {
          this.handleEndCall(true);
        });
      } else {
        this.websocket.send(JSON.stringify(res));
      }
      this.showCall = false;
    },
    makeDummyTrack(width = 640, height = 480) {
      let canvas = Object.assign(document.createElement("canvas"), {
        width,
        height,
      });
      canvas.getContext("2d").fillRect(0, 0, width, height);
      let stream = canvas.captureStream();
      this.videoTrack = Object.assign(stream.getVideoTracks()[0], {
        enabled: false,
      });
      this.stream.addTrack(this.videoTrack);
      this.dummyVideo = true;
    },
    makeDummyTrackAudio() {
      let ctx = new AudioContext(),
        oscillator = ctx.createOscillator();
      let dst = oscillator.connect(ctx.createMediaStreamDestination());
      oscillator.start();
      this.audioTrack = Object.assign(dst.stream.getAudioTracks()[0], {
        enabled: false,
      });
      this.stream.addTrack(this.audioTrack);
      this.dummyAudio = true;
    },
    async handleCall(usr_id) {
      await this.getUserMedia();
      this.peer = new Peer({
        initiator: true,
        trickle: false,
        stream: this.stream,
      });
      if (this.videoTrack === null) {
        this.peer.addTransceiver("video");
      }
      if (this.audioTrack === null) {
        this.peer.addTransceiver("audio");
      }
      this.caller.usr_id = usr_id;
      this.peer.on("close", () => {
        this.handleEndCall(true);
      });

      this.peer.on("error", (e) => console.log(e));
      this.peer.on("signal", (data) => {
        this.startLoading();
        this.websocket.send(
          JSON.stringify({
            usr_id: usr_id,
            type: "call",
            peer: data,
          })
        );
      });

      // this.peer.on('stream', stream => {
      //   this.otherStream = stream
      // })
      this.peer.on("track", (track) => {
        if (this.otherStream === null) {
          this.otherStream = new MediaStream();
        }
        this.otherStream.addTrack(track);
      });
    },
    connectWebSocket() {
      if (!this.webRTC || !this.isLoggedIn) {
        return;
      }
      if (this.websocket !== null) {
        this.websocket.send(JSON.stringify({ type: "check" }));
        return;
      }
      let sid = localStorage.getItem("sid");
      let protocol = location.protocol;
      let route = window.location.hostname + "/api/ws?sid=" + sid;
      if (process.env.NODE_ENV === "development") {
        protocol = process.env.VUE_APP_API_URL.startsWith("https")
          ? "https:"
          : "http:";
        route =
          process.env.VUE_APP_API_URL.substring(protocol.length) +
          "/ws?sid=" +
          sid;
      }
      protocol = protocol === "https:" ? "wss://" : "ws://";
      this.websocket = new WebSocket(protocol + route);
      this.websocket.onmessage = this.handleWsMessage;
      this.websocket.onopen = this.handleWsOpen;
      this.websocket.onerror = this.handleWsError;
      this.websocket.onclose = this.handleWsClose;
    },
    handleWsMessage(msg) {
      msg = JSON.parse(msg.data);
      switch (msg.status) {
        case "ok": {
          break;
        }
        case "invalid": {
          this.websocket.close();
          this.stopLoading();
          if (this.onCall || this.incomingCall) {
            this.handleEndCall(true);
          }
          this.websocket = null;
          break;
        }
        case "self": {
          this.handleEndCall(true);
          this.stopLoading();
          break;
        }
        case "call": {
          if (this.onCall || this.incomingCall) {
            this.websocket.send(
              JSON.stringify({
                type: "busy",
                destination: msg.destination,
                usr_id: msg.usr_id,
              })
            );
            return;
          }
          this.caller = msg;
          delete this.caller.status;
          this.incomingCall = true;
          this.$refs.audio.play();
          break;
        }
        case "tab-name": {
          this.tabName = msg.tabName;
          break;
        }
        case "on-call-other-tab": {
          if (!this.onCall) {
            this.handleEndCall(true);
          }
          break;
        }
        case "answer": {
          this.stopLoading();
          if (msg.answer) {
            this.otherPeer = msg.peer;
            this.caller.destination = msg.destination;
            this.peer.signal(this.otherPeer);
          } else {
            if (Number(msg.usr_id) === Number(this.caller.usr_id)) {
              this.openToast(this.$t("call.rejected"));
              this.handleEndCall(true);
            }
          }
          break;
        }
        case "calling": {
          this.stopLoading();
          this.onCall = true;
          break;
        }
        case "offline": {
          this.stopLoading();
          this.openToast(this.$t("call.offline"));
          this.handleEndCall(true);
          break;
        }
        case "end-call": {
          if (Number(msg.usr_id) === Number(this.caller.usr_id)) {
            this.handleEndCall(true);
          }
          break;
        }
        default:
          return;
      }
    },
    handleWsOpen(e) {
      // console.log(e);
    },
    handleWsError() {
      this.websocket = null;
    },
    handleWsClose() {
      this.websocket = null;
    },
    async getUserMedia() {
      if (!navigator.mediaDevices) {
        this.stream = null;
        return;
      }
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: {
            height: 720,
            width: 1280,
          },
        });
      } catch (error) {
        if (error.name === "NotFoundError") {
          try {
            this.stream = await navigator.mediaDevices.getUserMedia({
              audio: true,
            });
          } catch (error) {
            if (error.name === "NotFoundError") {
              console.log("no devices");
            }
            this.stream = null;
          }
        } else {
          console.warn(error);
          this.stream = null;
        }
      }
      if (this.stream !== null) {
        this.tracks = this.stream.getTracks();
        this.videoTrack = this.tracks.filter((el) => el.kind === "video");
        this.audioTrack = this.tracks.filter((el) => el.kind === "audio");
        if (this.videoTrack.length === 0) {
          this.makeDummyTrack();
        } else {
          this.videoTrack = this.videoTrack[0];
        }
        if (this.audioTrack.length === 0) {
          this.audioTrack = null;
        } else {
          this.audioTrack = this.audioTrack[0];
        }
      } else {
        this.stream = new MediaStream();
        this.makeDummyTrack();
        this.makeDummyTrackAudio();
      }
    },
    async getScreenShareStream() {
      if (!this.canShareScreen) {
        return;
      }
      if (!navigator.mediaDevices) {
        this.screenStream = null;
        return;
      }
      try {
        this.screenStream = await navigator.mediaDevices.getDisplayMedia({
          cursor: true,
          video: true,
        });
      } catch (error) {
        console.error(error);
      }
      if (this.screenStream !== null) {
        if (this.stream === null) {
          this.stream = this.screenStream;
        }
        this.screenShareTrack = this.screenStream.getTracks()[0];
        this.screenShareTrack.onended = this.stopScreenShare;
      }
    },
    async startScreenShare() {
      await this.getScreenShareStream();
      if (this.screenStream === null) {
        return;
      }
      if (
        this.stream
          .getTracks()
          .filter((el) => el.kind === "video")
          .findIndex((el) => el.id === this.screenShareTrack.id)
      ) {
        if (this.videoTrack !== null) {
          this.peer.replaceTrack(
            this.videoTrack,
            this.screenShareTrack,
            this.stream
          );
        } else {
          this.peer.addTrack(this.screenShareTrack, this.stream);
        }
      }
    },
    async stopScreenShare() {
      if (this.videoTrack !== null) {
        this.peer.replaceTrack(
          this.screenShareTrack,
          this.videoTrack,
          this.stream
        );
      } else {
        this.peer.removeTrack(this.screenShareTrack, this.stream);
        this.stream = null;
      }
      this.screenStream.getTracks().forEach((el) => el.stop());
      this.screenStream = null;
      this.screenShareTrack = null;
    },
    handleScreenShare(val) {
      if (val) {
        this.startScreenShare();
      } else {
        this.stopScreenShare();
      }
    },
    handleMuteSelf(val) {
      this.audioTrack.enabled = !val;
      this.muted = val;
    },
    handleHideVideo(val) {
      this.videoTrack.enabled = !val;
      this.hideVideo = val;
    },
    muteChime(val) {
      this.chimeMuted = val;
      this.$refs.audio.muted = val;
    },
    handleEndCall(fromWebsocket = false) {
      if (this.stream !== null) {
        this.stream.getTracks().forEach((el) => el.stop());
      }
      if (this.screenStream !== null) {
        this.screenStream.getTracks().forEach((el) => el.stop());
      }
      if (this.peer !== null) {
        this.peer.destroy();
        this.peer = null;
      }
      if (!fromWebsocket) {
        this.websocket.send(
          JSON.stringify({
            type: "end-call",
            usr_id: this.caller.usr_id,
            destination: this.caller.destination,
          })
        );
      }
      this.incomingCall = false;
      this.onCall = false;
      this.muted = false;
      this.hideVideo = false;
      this.stream = null;
      this.screenStream = null;
      this.videoTrack = null;
      this.audioTrack = null;
      this.screenShareTrack = null;
      this.otherStream = null;
      this.otherPeer = null;
      this.caller = {
        usr_id: null,
        usr_firstname: "",
        usr_lastname: "",
        destination: "",
      };
    },
    saveTitle() {
      this.ogTitle = document.title;
    },
    playAudioAndToggleTitle() {
      this.newMessageAudio.play();
      this.clearToggleTitle();
      this.toggleTitle();
    },
    clearToggleTitle() {
      if (this.titleToggleInterval) {
        clearInterval(this.titleToggleInterval);
        this.titleToggleInterval = null;
      }
    },
    toggleTitle() {
      const oldTitle = this.ogTitle;
      const newTitle = this.$t("chat.title");
      this.titleToggleInterval = setInterval(() => {
        let setTitle = document.title === oldTitle ? newTitle : oldTitle;
        document.title = setTitle;
      }, 1500);
    },
    resetTitle() {
      this.clearToggleTitle();
      document.title = this.ogTitle;
    },
    setAction(action) {
      this.action = action;
    },
    clearAction() {
      this.action = null;
    },
    goHome() {
      this.$router.push("/");
    },
    // goBack(){
    //   this.EventBus.$emit('stopVideo')
    //   this.$router.go(-1)
    // }
  },
};
</script>

<style lang="scss" scoped>
.app {
  max-width: 100%;
  .icon-wrap {
    position: fixed;
    top: calc(3% + var(--nav-height));
    right: 3%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
    width: 32px;
    height: 32px;
    cursor: pointer;
    background: #ffffff93;
    border-radius: 50%;

    &.fullscreen {
      position: fixed;
    }
    &.home {
      right: calc(3% + 80px);
    }
    &.back {
      right: calc(3% + 150px);
    }
    .material-icons {
      display: block;
    }
  }
}
.page {
  position: relative;
  min-height: var(--page-height-landscape);
  padding-left: var(--nav-height);
  margin-top: var(--nav-height);
  &.fullscreen {
    padding: 0;
    margin: var(--nav-height) 0 0 0px;
  }
  &.portrait {
    padding-left: 0;
    min-height: var(--page-height-portrait);
    // padding-bottom: var(--nav-height);
  }
  &.no-side-bar {
    padding-left: 0;
    min-height: var(--page-height-landscape);
  }
  &.no-nav-bar {
    margin-top: 0;
  }
  &.has-footer {
    min-height: calc(var(--page-height-landscape) - var(--footer-height));
  }
}
.background-dim {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
}
.no-scroll {
  overflow: hidden;
}
.hidden {
  display: none !important;
}
@media only screen and (max-width: 895px) {
  .icon-wrap {
    &.home {
      right: calc(3% + 90px) !important;
    }
    &.back {
      right: calc(3% + 134px) !important;
    }
    .material-icons {
      display: block;
    }
  }
}
</style>

<style>
#onesignal-bell-container {
  bottom: 14px !important;
  right: 140px !important;
}
</style>
